module.exports = __webpack_public_path__ + "static/shades-472779f4fb0d232e4205946b270ce9a0.png";